import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BdSearch } from 'components/_controls/BdSearch';

import diseaseActivitiesGlobalSelectors from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.selectors';
import { searchDiseases } from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.slice';

export const GlobalDiseaseSearch: React.FC = () => {
  const dispatch = useDispatch();
  const searchString = useSelector(diseaseActivitiesGlobalSelectors.getSearchText);

  return (
    <BdSearch
      placeholder="Search for diseases"
      debounceDelay={200}
      searchText={searchString}
      onSearchTextChange={text => dispatch(searchDiseases(text))}
      bottomBorderOnly
    />
  );
};
